import { styled } from '@mui/material';

export const AStyled = styled('a')(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));
